import React from 'react'
import { renderArticleContent, renderArticleLinks } from '../../markdown'

import getLayout from './layouts'
import { withDispatch } from 'store'
import { useContent, getContent } from 'store/article'

import { toInt } from 'util/conversion'

export const ContentLayout = ({ WrapComponent = React.Fragment, id, categoryId }) => {
  const { content = [], id: articleId } = useContent(id)

  const renderedContent = React.useMemo(() => renderArticleContent({ content }), [content])

  return content.map(({ id, body, layout }) => {
    const Component = getLayout(layout)
    const children = renderedContent[id]
    return (
      <WrapComponent key={id}>
        <Component
          source={body}
          layout={layout}
          articleId={articleId}
          id={id}
          key={id}
          categoryId={categoryId}
        >
          {children}
        </Component>
      </WrapComponent>
    )
  })
}
ContentLayout.getInitialProps = async ({
  store,
  id,
  fetchMissingArticles,
  fetchMissingAuthors,
  fetchMissingTopics,
}) => {
  const { content = [] } = getContent(store, id)

  const { article = [], topic = [], author = [] } = renderArticleLinks({ content }).linkMap
  await Promise.all([
    fetchMissingTopics(topic),
    fetchMissingAuthors(author),
    fetchMissingArticles(article),
  ])
}
export default withDispatch({
  shared: ['fetchMissingArticles', 'fetchMissingAuthors', 'fetchMissingTopics'],
})(ContentLayout)
